import { clsx } from 'clsx';
import { type FC } from 'react';

import type { IconName } from '@repo/icons';

export type IconSizes = {
  /** Size of the icon in pixels. Default is 24. */
  size?: 12 | 16 | 18 | 20 | 24 | 32 | 40;
};

export type SpriteIconProps = IconSizes & {
  name: IconName;
  /** Public URL of the app’s hashed sprite (from `sprite.generated.ts`). */
  spriteUrl: string;
  className?: string;
  'data-testid'?: string;
};

export const SpriteIcon: FC<SpriteIconProps> = ({
  size = 24,
  name,
  spriteUrl,
  className,
  'data-testid': dataTestId,
}) => {
  return (
    <svg
      data-testid={dataTestId}
      className={clsx('relative block fill-current', className, {
        'size-3': size === 12,
        'size-4': size === 16,
        'size-4.5': size === 18,
        'size-5': size === 20,
        'size-6': size === 24,
        'size-8': size === 32,
        'size-10': size === 40,
      })}
    >
      <use href={`${spriteUrl}#${name}`} />
    </svg>
  );
};
